type LegacyWindow = Window & { orientation?: number };

export function detectIsPortrait(): boolean {
  if (window.screen.orientation) {
    return window.screen.orientation.type.includes("portrait");
  }
  if ("orientation" in (window as LegacyWindow)) {
    const angle = (window as LegacyWindow).orientation;
    return Math.abs(angle ?? 0) !== 90;
  }
  try {
    if (window.matchMedia?.("(orientation: portrait)").matches) {
      return true;
    }
  } catch { /* matchMedia unavailable in some webviews */ }
  return window.innerHeight > window.innerWidth;
}
